
{
  "fr": {
    "configuratorLayerEditorModalAiGenImage": {
      "placeholder": "Saisissez un texte pour commencer à générer une image.\nChaque génération a un coût énergétique et un impact environnemental. Merci d'utiliser cet outil de manière responsable.",
      "submit": "Envoyer",
      "inputPlaceholder": "Un astronaute à cheval, une banane qui fait du skate, ...",
      "loading": "Génération en cours..."
    }
  }
}
